// Layout changes presentation only; callers supply already-authorized items.
export const navigationGroups = ['Daily work', 'Clinical', 'Billing & PI', 'Practice'];
const orders = {
  owner: ['/for-you','/schedule','/patients','/billing','/messages','/dashboard'],
  doctor: ['/for-you','/schedule','/patients','/clinical','/messages','/pi'],
  ca: ['/for-you','/schedule','/patients','/front-desk-tasks','/messages','/pi'],
  billing_staff: ['/for-you','/schedule','/billing','/patients','/pi','/messages'],
  office_manager: ['/for-you','/schedule','/patients','/front-desk-tasks','/billing','/messages'],
};
export function navigationLayout(visible, role, compact=false) {
  const preferred=orders[role] || ['/for-you','/schedule','/patients','/messages'];
  const candidates=preferred.map(to=>visible.find(item=>item.to===to)).filter(Boolean);
  // Preserve frequent clinical tasks in a single row beside office/account controls.
  // Everything else remains in More, with the existing role/feature filtering.
  const compactOrder=['/for-you','/schedule','/patients','/messages'];
  const primary=compact
    ? compactOrder.map(to=>visible.find(item=>item.to===to)).filter(Boolean)
    : candidates.slice(0,6);
  const secondary=visible.filter(item=>!primary.some(p=>p.to===item.to));
  return {primary,secondary};
}
export function sectionForPath(items, pathname) {
  return items.find(item=>pathname===item.to || pathname.startsWith(item.to+'/'));
}
